import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {
  zh: {
    nav: { home: '首页', products: '产品中心', solutions: '解决方案', cases: '案例展示', news: '新闻中心', about: '关于我们', contact: '联系我们', downloads: '下载中心' },
    home: {
      slogan: '赋能未来',
      title: '全球领先的能源解决方案提供商',
      subtitle: '致力于为全球客户提供高效、可靠、可持续的能源产品与服务',
      explore: '探索更多',
      contactUs: '联系我们',
      productsTitle: '核心产品',
      productsDesc: '高品质的能源产品，满足多样化需求',
      solutionsTitle: '解决方案',
      solutionsDesc: '针对不同行业的定制化能源解决方案',
      partners: '合作伙伴',
      globalTitle: '全球业务',
      globalDesc: '业务遍布全球多个国家和地区的能源市场',
      certificates: '资质荣誉',
      certificatesDesc: '通过多项国际认证，品质值得信赖'
    },
    footer: { quickLinks: '快速链接', contactInfo: '联系信息', socialMedia: '社交媒体', copyright: '© 2024 Energy Corp. 保留所有权利。', address: '地址', phone: '电话', email: '邮箱' },
    contact: { name: '姓名', email: '邮箱', phone: '电话', subject: '主题', message: '留言内容', send: '发送留言', title: '联系我们', desc: '我们期待与您的合作，请随时联系我们', required: '请填写此项', emailInvalid: '请输入有效的邮箱地址', sentSuccess: '发送成功！', sendFailed: '发送失败，请重试', whatsappLabel: 'WhatsApp 咨询', telegramLabel: 'Telegram 咨询', linkedinLabel: 'LinkedIn 主页', wechatLabel: '微信号', wechatCopied: '微信号已复制，请打开微信搜索添加', qqLabel: 'QQ 咨询', qqCopied: 'QQ号已复制，请打开QQ搜索添加', weiboLabel: '微博主页', douyinLabel: '抖音主页', floatCta: '在线留言', floatTitle: '快速留言', floatTip: '填写以下信息，我们会尽快与您联系。' },
    case: {
      detail: '查看详情', noData: '暂无案例数据',
      industry: { power: '电力', petrochemical: '石化', new_energy: '新能源', manufacturing: '制造业', transportation: '交通', construction: '建筑' }
    },
    common: { all: '全部', notFound: '未找到相关内容，它可能已被删除', loadFailed: '加载失败，请稍后重试', retry: '重新加载',
      pageNotFoundTitle: '页面未找到', pageNotFoundDesc: '您访问的页面不存在或已被移动', backHome: '返回首页' }
  },
  en: {
    nav: { home: 'Home', products: 'Products', solutions: 'Solutions', cases: 'Cases', news: 'News', about: 'About', contact: 'Contact', downloads: 'Downloads' },
    home: {
      slogan: 'POWERING THE FUTURE',
      title: 'Global Leading Energy Solutions Provider',
      subtitle: 'Committed to delivering efficient, reliable, and sustainable energy products and services worldwide',
      explore: 'Explore More',
      contactUs: 'Contact Us',
      productsTitle: 'Core Products',
      productsDesc: 'High-quality energy products for diverse needs',
      solutionsTitle: 'Solutions',
      solutionsDesc: 'Customized energy solutions for different industries',
      partners: 'Our Partners',
      globalTitle: 'Global Presence',
      globalDesc: 'Operating in energy markets across multiple countries and regions',
      certificates: 'Certifications',
      certificatesDesc: 'Certified by multiple international standards'
    },
    footer: { quickLinks: 'Quick Links', contactInfo: 'Contact Info', socialMedia: 'Social Media', copyright: '© 2024 Energy Corp. All rights reserved.', address: 'Address', phone: 'Phone', email: 'Email' },
    contact: { name: 'Name', email: 'Email', phone: 'Phone', subject: 'Subject', message: 'Message', send: 'Send Message', title: 'Contact Us', desc: 'We look forward to cooperating with you. Feel free to reach out.', required: 'This field is required', emailInvalid: 'Please enter a valid email address', sentSuccess: 'Sent successfully!', sendFailed: 'Failed, please retry', whatsappLabel: 'WhatsApp Chat', telegramLabel: 'Telegram Chat', linkedinLabel: 'LinkedIn Profile', wechatLabel: 'WeChat ID', wechatCopied: 'WeChat ID copied, please open WeChat to search and add', qqLabel: 'QQ Chat', qqCopied: 'QQ ID copied, please open QQ to search and add', weiboLabel: 'Weibo Profile', douyinLabel: 'Douyin Profile', floatCta: 'Quick Inquiry', floatTitle: 'Send Us a Message', floatTip: 'Fill in the form below and we will get back to you shortly.' },
    case: {
      detail: 'View Details', noData: 'No cases yet',
      industry: { power: 'Power', petrochemical: 'Petrochemical', new_energy: 'New Energy', manufacturing: 'Manufacturing', transportation: 'Transportation', construction: 'Construction' }
    },
    common: { all: 'All', notFound: 'The requested content was not found or has been removed', loadFailed: 'Failed to load, please try again later', retry: 'Retry',
      pageNotFoundTitle: 'Page Not Found', pageNotFoundDesc: 'The page you are looking for does not exist or has been moved', backHome: 'Back to Home' }
  },
  ru: {
    nav: { home: 'Главная', products: 'Продукты', solutions: 'Решения', cases: 'Кейсы', news: 'Новости', about: 'О нас', contact: 'Контакты', downloads: 'Загрузки' },
    home: {
      slogan: 'ЭНЕРГИЯ БУДУЩЕГО',
      title: 'Ведущий мировой поставщик энергетических решений',
      subtitle: 'Стремимся предоставлять эффективные, надёжные и устойчивые энергетические продукты и услуги по всему миру',
      explore: 'Узнать больше',
      contactUs: 'Связаться',
      productsTitle: 'Продукты',
      productsDesc: 'Высококачественная энергетическая продукция',
      solutionsTitle: 'Решения',
      solutionsDesc: 'Индивидуальные решения для различных отраслей',
      partners: 'Партнёры',
      globalTitle: 'Глобальное присутствие',
      globalDesc: 'Работаем на энергетических рынках многих стран мира',
      certificates: 'Сертификаты',
      certificatesDesc: 'Сертифицировано по международным стандартам'
    },
    footer: { quickLinks: 'Ссылки', contactInfo: 'Контакты', socialMedia: 'Соцсети', copyright: '© 2024 Energy Corp. Все права защищены.', address: 'Адрес', phone: 'Телефон', email: 'Почта' },
    contact: { name: 'Имя', email: 'Почта', phone: 'Телефон', subject: 'Тема', message: 'Сообщение', send: 'Отправить', title: 'Контакты', desc: 'Мы рады сотрудничеству. Свяжитесь с нами.', required: 'Это поле обязательно', emailInvalid: 'Введите корректный email', sentSuccess: 'Отправлено!', sendFailed: 'Ошибка отправки, попробуйте снова', whatsappLabel: 'Написать в WhatsApp', telegramLabel: 'Написать в Telegram', linkedinLabel: 'Профиль LinkedIn', wechatLabel: 'WeChat ID', wechatCopied: 'WeChat ID скопирован, откройте WeChat для поиска', qqLabel: 'QQ чат', qqCopied: 'QQ ID скопирован, откройте QQ для поиска', weiboLabel: 'Профиль Weibo', douyinLabel: 'Профиль Douyin', floatCta: 'Написать нам', floatTitle: 'Оставить заявку', floatTip: 'Заполните форму, и мы свяжемся с вами в ближайшее время.' },
    case: {
      detail: 'Подробнее', noData: 'Нет кейсов',
      industry: { power: 'Энергетика', petrochemical: 'Нефтехимия', new_energy: 'Новая энергия', manufacturing: 'Производство', transportation: 'Транспорт', construction: 'Строительство' }
    },
    common: { all: 'Все', notFound: 'Запрашиваемая информация не найдена или была удалена', loadFailed: 'Не удалось загрузить, попробуйте позже', retry: 'Повторить',
      pageNotFoundTitle: 'Страница не найдена', pageNotFoundDesc: 'Запрашиваемая страница не существует или была перемещена', backHome: 'На главную' }
  }
}

const i18n = new VueI18n({
  locale: localStorage.getItem('portal_lang') || 'ru',
  messages,
  fallbackLocale: 'ru'
})

export default i18n
